module.exports = __webpack_public_path__ + "assets/489d3ce2fb792c6bd5c2caf7ee1b2ddc.png";